export const methods = {
  post,
  get,
};

function post(body) {
  const user = JSON.parse(sessionStorage.getItem("user"));

  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + user.token,
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: body,
  };

  return [user, requestOptions];
}

function get(body) {
  const user = JSON.parse(sessionStorage.getItem("user"));

  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + user.token,
      "Content-Type": "application/json",
    },
    body: body,
  };

  return [user, requestOptions];
}
